module.exports = function () {

	function generateNewItemFields(index, suggestions, selectExpenditureForm, selectBankAccountForm, today, duplicated) {

		if(typeof duplicated !== 'undefined'){
			var date = duplicated.date, creditor = duplicated.creditor, status = '';

			if(duplicated.status == 0){
				var status = 'selected=selected';
			}

		} else{
			var date = today, status = '', creditor = '';
		}

		var newFieldGroup =
				'<div class="main_item">' +
					'<label for="row_' + index + '" style="border-bottom: 1px solid #0a7280;">Property: ' + suggestions.name + ' </label>' +
					'<div class="row" id="row_' + index + '" style="margin-bottom: 10px; padding: 10px; background: rgba(10, 114, 128, 0.07);">' +
						'<input name="expenditures[' + index + '][property_id]" type="hidden" value="' + suggestions.id + '"/>' +
						'<input name="expenditures[' + index + '][property_name]" type="hidden" value="' + suggestions.name + '"/>' +
						'<div class="row">' +
							'<div class="col-sm-1 pull-left">'+
								'<button class="btn btn-remove" type="button" style="border: none; background: transparent; color: red; font-weight: bold;">Delete</button>'+
							'</div>' +
							'<div class="col-sm-4">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][type_id]" class="control-label label-required col-sm-5">Expenditure</label>'+
									'<div class="col-sm-7">' + selectExpenditureForm + '</div>'+
								'</div>'+
							'</div>' +
							'<div class="col-sm-3">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][date]" class="control-label col-sm-5 label-required">Date</label>'+
									'<div class="col-sm-7">'+
										'<input class="form-control js-datepicker" name="expenditures[' + index + '][date]" type="text" id="expenditures[' + index + '][date]" value="'+ date +'">'+
									'</div>'+
								'</div>'+
							'</div>' +
						'</div>' +
						'<div class="row">' +
							'<div class="col-sm-1 pull-left">'+
								'<button class="btn btn-duplicate" type="button" style="border: none; background: transparent; color: blue; font-weight: bold;" data-index="' + index + '">Duplicate</button>'+
							'</div>' +
							'<div class="col-sm-4">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][creditor]" class="control-label col-sm-5 label-required">Creditor</label>'+
									'<div class="col-sm-7">'+
										'<input class="form-control" required="required" name="expenditures[' + index + '][creditor]" type="text" id="expenditures[' + index + '][creditor]" value="'+creditor+'">'+
									'</div>'+
								'</div>'+
							'</div>' +
							'<div class="col-sm-3">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][amount_paid]" class="control-label col-sm-5 label-required">Amount Paid</label>'+
									'<div class="col-sm-7">'+
										'<input class="form-control" required="required" name="expenditures[' + index + '][amount_paid]" type="text" id="expenditures[' + index + '][amount_paid]">'+
									'</div>'+
								'</div>'+
							'</div>' +
							'<div class="col-sm-4">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][invoice_number]" class="control-label col-sm-5 label-required">Invoice number</label>'+
									'<div class="col-sm-7">'+
										'<input class="form-control" required="required" name="expenditures[' + index + '][invoice_number]" type="text" id="expenditures[' + index + '][invoice_number]">'+
									'</div>'+
								'</div>'+
							'</div>' +
						'</div>' +
						'<div class="row">' +
							'<div class="col-sm-1 pull-left"></div>' +
							'<div class="col-sm-4">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][bank_account_id]" class="control-label col-sm-5">GG Bank Account</label>'+
									'<div class="col-sm-7">' + selectBankAccountForm + '</div>'+
								'</div>'+
							'</div>' +
							'<div class="col-sm-7">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][purchase_order_number]" class="control-label col-sm-5">Purchase order number</label>'+
									'<div class="col-sm-7">'+
										'<input class="form-control" name="expenditures[' + index + '][purchase_order_number]" type="text" id="expenditures[' + index + '][purchase_order_number]">'+
									'</div>'+
								'</div>'+
							'</div>' +
							'<div class="col-sm-12">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][description]" class="control-label col-sm-5">Description</label>'+
									'<div class="col-sm-7">'+
										'<textarea class="form-control" name="expenditures[' + index + '][description]" type="text" id="expenditures[' + index + '][description]"></textarea>'+
									'</div>'+
								'</div>'+
							'</div>' +
						'</div>' +
			            '<div class="row">' +
				            '<div class="col-sm-1 pull-left"></div>' +
            				'<div class="col-sm-12">'+
								'<div class="form-group">'+
									'<label for="expenditures[' + index + '][file]" class="control-label col-sm-5">Invoice</label>'+
									'<div class="col-sm-7">'+
										'<div class="input-image">'+
											'<input class="form-control" name="expenditures[' + index + '][file]" type="file" id="expenditures[' + index + '][file]">'+
										'</div>'+
									'</div>'+
								'</div>'+
							'</div>' +
            			'</div>'+
						'<div class="row">' +
			  				'<div class="col-sm-1 pull-left"></div>' +
            				'<div class="col-sm-12">'+
            					'<div class="form-group">'+
            						'<label for="expenditures[' + index + '][confirmation_file]" class="control-label col-sm-5">Confirmation File</label>'+
            						'<div class="col-sm-7">'+
            							'<div class="input-image">'+
            								'<input class="form-control" name="expenditures[' + index + '][confirmation_file]" type="file" id="expenditures[' + index + '][confirmation_file]">'+
            							'</div>'+
            						'</div>'+
            					'</div>'+
            				'</div>' +
            			'</div>'+
            		'</div>' +
				'</div>';
		return newFieldGroup;
	}

	$(document).ready(function () {

		var helper = require('../../helper');
		var moment = require('moment');

		var today = moment( new Date() ).format('DD/MM/YYYY');

		/*********************
		 * TYPEAHEAD SECTION *
		 *********************/
		/** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/properties/with-expenditures/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        name: object.name,
                        property_id: object.property_id,
                        responseExpenditures: object.responseExpenditures,
	                    bankAccounts: object.bankAccounts
                    };
                });
            }
        });

        /** Run TypeAhead */
        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'name',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'name',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + ' (' + data.property_id + ')' + '</strong></p>';
                }
            },
            source: engine
        });


        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/
        $('.js-property-field-typeahead').bind('typeahead:select', function (ev, suggestions) {

            var $this = $(this),
                index = $this.data('index');

            var selectExpenditureForm = '<select id="expenditures[' + index + '][type_id]" name="expenditures[' + index + '][type_id]" class="form-control" required="required" style="font-size: 12px;">';
            $.each(suggestions.responseExpenditures, function(key, value){
                var option = '<option disabled>' + key + '</option>';
                selectExpenditureForm += option;

                $.each(value, function(k, v){
                    var option = '<option value="'+ k +'">' + v + '</option>';
                    selectExpenditureForm += option;
                });
            });
            selectExpenditureForm += '</select>';

	        var selectBankAccountForm = '<select id="expenditures[' + index + '][bank_account_id]" name="expenditures[' + index + '][bank_account_id]" class="form-control" style="font-size: 12px;">';
	        $.each(suggestions.bankAccounts, function(key, value){
		        var option = '<option value="'+ key +'">' + value + '</option>';
		        selectBankAccountForm += option;
	        });
	        selectBankAccountForm += '</select>';

            var newFieldGroup = generateNewItemFields(index, suggestions, selectExpenditureForm, selectBankAccountForm, today);

            var controlForm = $('.controls');

            $(newFieldGroup).appendTo(controlForm);

            $('#new_field_input').val('');

            $this.data('index', ++index)
        });

        $(document).on('click', '.js-datepicker', function (e) {

            $(this).datepicker({
                autoclose: true,
                format: "dd/mm/yyyy"
            });


        }).on('click', '.btn-remove', function (e) {

            $(this).parents('.row:first').parents('.row:first').parents('.main_item').remove();
            // add removing label

            e.preventDefault();
            return false;

        }).on('click', '.btn-duplicate', function (e) {

	      console.log('clicked duplicate');

	        var     $this = $(this),
                    index = $this.data('index'),
                    selectPropertyWithIndexInput = $('.js-property-field-typeahead'),
			        globalIndex = selectPropertyWithIndexInput.data('index'),
			        selectExpenditure = $('select[name="expenditures[' + index + '][type_id]"]'),
			        selectExpenditureSelected = $('select[name="expenditures[' + index+ '][type_id]"]').val(),
			        selectBankAccount = $('select[name="expenditures[' + index + '][bank_account_id]"]'),
			        selectBankAccountSelected = $('select[name="expenditures[' + index+ '][bank_account_id]"]').val(),
			        replaceThis = 'expenditures\\['+index+'\\]',
			        selectExpenditureForm = selectExpenditure.parent().html().replace( new RegExp(replaceThis, 'g' ), 'expenditures['+(globalIndex+1)+']'),
			        selectBankAccountForm = selectBankAccount.parent().html().replace( new RegExp(replaceThis, 'g' ), 'expenditures['+(globalIndex+1)+']'),
			        copiedStatus = $('select[name="expenditures[' + index + '][status]"]').val(),
			        copiedDate = $('input[name="expenditures[' + index + '][date]"]').val(),
			        copiedCreditor = $('input[name="expenditures[' + index + '][creditor]"]').val(),
			        suggestions = { name: $('input[name="expenditures[' + index + '][property_name]"]').val(), id:$('input[name="expenditures[' + index + '][property_id]"]').val() },
			        duplicated = { status : copiedStatus, date : copiedDate, creditor : copiedCreditor }
			        ;


	        var newFieldGroup = generateNewItemFields(++globalIndex, suggestions, selectExpenditureForm, selectBankAccountForm, today, duplicated);

	        var controlForm = $('.controls');

	        $(newFieldGroup).appendTo(controlForm);

	        $('select[name="expenditures[' + globalIndex + '][type_id]"]').val(selectExpenditureSelected);
			$('select[name="expenditures[' + globalIndex + '][bank_account_id]"]').val(selectBankAccountSelected);

	        selectPropertyWithIndexInput.data('index', globalIndex);

        });

    });
}();
